import { Insured } from './insured.model';
import { PaymentMethod } from './payment-method.model';
import { Policy } from './policy.model';
import { Producer } from './producer.model';

export class DataStorage {
    branch: number;
    insured: Insured;
    jobNumber: string;
    paymentMethod: PaymentMethod;
    paymentMethods: Array<PaymentMethod>;
    selectedPaymentTypeId: string;
    groupId: string;
    policy: Policy;
    policyPeriodId: string;
    producer: Producer;
    isRecovery: boolean;
    risk: any;
    opportunityId: string;

    constructor() {
        this.branch = null;
        this.insured = new Insured();
        this.jobNumber = null;
        this.paymentMethod = new PaymentMethod();
        this.selectedPaymentTypeId = null;
        this.paymentMethods = [];
        this.groupId = null;
        this.policy = new Policy();
        this.policyPeriodId = null;
        this.producer = new Producer();
        this.risk = null;
    }
}
